import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const isOverlayModal = (path) =>
  Boolean(
    path &&
      (path.includes('/padaria/') ||
        path.endsWith('/termos-de-uso') ||
        path.endsWith('/lgpd'))
  );

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    const prevPath = prevPathRef.current;
    prevPathRef.current = pathname;

    if (isOverlayModal(pathname) || isOverlayModal(prevPath)) {
      return;
    }

    const isPremiacoes = pathname.startsWith('/premiacoes-');
    const savedScroll = sessionStorage.getItem('lastScroll');

    if (isPremiacoes || !savedScroll) {
      window.scrollTo(0, 0);
      if (isPremiacoes) {
        sessionStorage.removeItem('lastScroll');
      }
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
